export const dateTransform = {
  mask: (value: string): string => {
    if (!value) {
      return value;
    }

    let resultValue = value
      .replace(/[^\d]/g, '')
      .split('')
      .reduce((acc, char) => acc.replace('D', char), 'DD/DD/DDDD');

    let lastDigitPosition = 0;
    resultValue.split('').forEach((char, i) => {
      if (char.match(/\d/)) {
        lastDigitPosition = i;
      }
    });

    resultValue = resultValue
      .split('')
      .slice(0, lastDigitPosition + 1)
      .join('');

    return resultValue;
  },
  mapper: (value: React.ChangeEvent<HTMLInputElement> | undefined): string => {
    const returnValue = value?.target?.value
      ? value?.target.value.replace(/[^\d]/g, '')
      : '';
    return returnValue;
  },
};
